import React, { useEffect } from 'react';
import './App.scss';
import Game from './Game/Game';
import store from './store';
import { Provider } from 'react-redux';
import { BROWSER_INFO_EVENT_NAME, appInsights } from './api/appInsights';
import { BagSystem, bags } from './helpers/BagSystem';
import { LOCATION_CLASSES, MONSTER_CLASSES } from './Enums/Attributes';

function App() {

  useEffect(() => {
    if (appInsights && appInsights.instance) {
      //appInsights.instance.loadAppInsights();
      //appInsights.instance.trackPageView();

      const browserInfo = {
        userAgent: window.navigator.userAgent,
        browserName: window.navigator.appName,
        browserVersion: window.navigator.appVersion,
        screenHeight: window.screen.height,
        screenWidth: window.screen.width,
      };

      appInsights.trackEvent({ name: BROWSER_INFO_EVENT_NAME, properties: browserInfo });
    }

    bags.monsters = new BagSystem(MONSTER_CLASSES.filter(x => !x.boss));
    bags.bosses = new BagSystem(MONSTER_CLASSES.filter(x => !!x.boss));
    bags.backgrounds = new BagSystem(LOCATION_CLASSES);
  }, [])

  return (
    <div className="App">
      <Provider store={store}>
        <Game />
      </Provider>
    </div>
  );
}

export default App;
